// PLP/SRP Events
export const VIEW_ITEM_LIST = 'view_item_list';
export const SELECT_ITEM = 'select_item';

// PDP Events
export const VIEW_ITEM = 'view_item';
export const ADD_TO_CART = 'add_to_cart';

// Cart Page Events
export const VIEW_CART = 'view_cart';
export const REMOVE_FROM_CART = 'remove_from_cart';
export const BEGIN_CHECKOUT = 'begin_checkout';

// Checkout Events
export const ADD_SHIPPING_INFO = 'add_shipping_info';
export const ADD_PAYMENT_INFO = 'add_payment_info';

// Thank You Page Events
export const PURCHASE = 'purchase';

// User Auth Events
export const LOGIN = 'login';
export const SIGN_UP = 'sign_up';

// Account Order History Events (Custom)
export const VIEW_ORDER_LIST = 'view_order_list';
export const VIEW_ORDER_DETAILS = 'view_order_details';
